module.exports = __webpack_public_path__ + "img/four-dots.17e95f3c.svg";